import React, { memo, ReactElement } from 'react';
import classNames from 'classnames';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Logo } from 'components/shared/Logo';

import css from './mainPageMobileHeaderTypeSimpleDates.module.sass';

interface Props {
  className?: string;
  leftBtnIcon?: ReactElement;
  rightBtnIcon?: ReactElement;
  onLeftBtnClick?: (() => void) | null;
  onRightBtnClick?: (() => void) | null;
}

export const MainPageMobileHeaderTypeSimpleDates: React.FC<Props> = memo(
  ({
    className,
    leftBtnIcon,
    rightBtnIcon,
    onLeftBtnClick,
    onRightBtnClick,
  }) => {
    return (
      <header className={classNames(css.root, className)}>
        {leftBtnIcon && onLeftBtnClick && (
          <BaseButton
            type={ButtonTypes.Transparent}
            className={classNames(css.btn, css.btnTypeOffer)}
            ariaLabel="open special offer or setting"
            onClick={onLeftBtnClick}
          >
            {leftBtnIcon}
          </BaseButton>
        )}
        <BaseButton
          type={ButtonTypes.Transparent}
          ariaLabel="home"
          to="/finder"
        >
          <Logo dark hideBottomLine small />
        </BaseButton>
        {rightBtnIcon && onRightBtnClick && (
          <BaseButton
            type={ButtonTypes.Transparent}
            className={classNames(css.btn, css.btnTypeFilter)}
            ariaLabel="open filters or settings"
            onClick={onRightBtnClick}
          >
            {rightBtnIcon}
          </BaseButton>
        )}
      </header>
    );
  }
);
